import { render, staticRenderFns } from "./Advertise.vue?vue&type=template&id=c6c080c2&"
import script from "./Advertise.vue?vue&type=script&lang=js&"
export * from "./Advertise.vue?vue&type=script&lang=js&"
import style0 from "./Advertise.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports